import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ConsultarSubcuentasRequest } from '../../models/cotizador-contratante/consultar-subcuentas/request/consultar-subcuentas-request.model';
import { ConsultarSubcuentasResponse } from '../../models/cotizador-contratante/consultar-subcuentas/ressponse/consultar-subcuentas-response.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultarSubcuentasService {
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.CONSULTAR_SUBCUENTAS}`;

  constructor(private httpClient: HttpClient) { }

  consultarSubcuentas(programa: string): Observable<ConsultarSubcuentasResponse> {
    const request: ConsultarSubcuentasRequest = {
      nombreClave: 'getSpSubcuentaPrograma',
      jsonParametros: JSON.stringify({ prm_programa: programa })
    };

    return this.httpClient.post<ConsultarSubcuentasResponse>(this.apiUrl, request).pipe(
      catchError(error => {
        console.error('Error en consultarSubcuentas: ', error);
        return throwError(() => new Error(error?.message || 'Error al consultar subcuentas'));
      })
    );
  }
}
